// ─── Aide & tutoriels (Core) ─────────────────────────────────────
// Registry d'aide PAR FONCTION, composé par l'app à partir de ses modules
// (feature-calendar/aides.js…). Chaque entrée :
//   { titre, intro, sections:[{titre,texte}], tutos?:[{titre,etapes:[texte…]}] }
// Le composant <AideFonction cle="…" /> (bouton ℹ️) lit ici le contenu.
import React, { createContext, useContext, useMemo } from 'react';

const AideContext = createContext(null);
export const useAide = () => useContext(AideContext) || { aideDe: () => null, contenus: {} };

export function AideProvider({ contenus = {}, children }) {
  const value = useMemo(() => ({
    contenus,
    aideDe: (cle) => contenus[cle] || null,
  }), [contenus]);
  return <AideContext.Provider value={value}>{children}</AideContext.Provider>;
}
